import { Grid, Typography } from '@material-ui/core';
import { GetApp, InsertDriveFile } from '@material-ui/icons';
import { investidorPfDocumentTypeDescriptions, investidorPjDocumentTypeDescriptions } from 'common/genericDescriptions';
import { InvestidorResponse } from 'common/genericTypes';
import { Button, MdSpace, Section } from 'm2m.components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

interface InvestidorDocumentosProps {
  investidor: InvestidorResponse;
}

const InvestidorDocumentosComponent: React.FC<InvestidorDocumentosProps> = (props) => {
  const {
    investidor: { id: investidorId, documentos, cpfCnpj },
  } = props;
  const investidorDocumentTypeDescriptions =
    cpfCnpj.length > 11 ? investidorPjDocumentTypeDescriptions : investidorPfDocumentTypeDescriptions;

  const dispatch = useDispatch();
  const { getDocumentDownloadUrl } = useSelector((state: RootState) => state.investidorApi);

  const getAttachmentLink = async (documentId: string, name: string) => {
    try {
      const result = await getDocumentDownloadUrl(dispatch, investidorId, documentId, true);

      if (result) {
        const link = document.createElement('a');
        link.href = result;
        link.target = '_blank';
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Section title={'Documentos'}>
      {documentos.map((documento, index) => (
        <>
          {!!index && <MdSpace />}
          <Grid
            key={documento.id}
            container
            spacing={2}
            justify={'space-between'}
            style={{
              borderBottom: '1px solid #C4C4C4',
              paddingBottom: '20px',
              minWidth: '700px',
            }}
          >
            <Grid item md={4}>
              <Typography variant="body1">
                {investidorDocumentTypeDescriptions[documento.investidorDocumentType]}
              </Typography>
            </Grid>
            <Grid item md>
              <InsertDriveFile style={{ marginRight: 20 }} />
              <Typography variant="body1" display="inline">
                {documento.fileName} - {`${Math.round((documento.size / 1000000) * 100) / 100}MB`}
              </Typography>
            </Grid>
            <Grid item>
              <Button
                style={{ height: 'fit-content' }}
                startIcon={<GetApp />}
                onClick={() => getAttachmentLink(documento.id, documento.fileName)}
                variant="text"
              >
                {'Download'}
              </Button>
            </Grid>
          </Grid>
        </>
      ))}
    </Section>
  );
};

export const InvestidorDocumentos = InvestidorDocumentosComponent;
